export default __webpack_public_path__ + "static/media/stories_white.4a8c3504.svg";